import { render, staticRenderFns } from "./DashboardSystemStatus.vue?vue&type=template&id=634fa4d3&scoped=true&"
import script from "./DashboardSystemStatus.vue?vue&type=script&lang=js&"
export * from "./DashboardSystemStatus.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSystemStatus.vue?vue&type=style&index=0&id=634fa4d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634fa4d3",
  null
  
)

export default component.exports